import type { CategoryContent } from '../row.js';

export const PHOTOGRAPHY: CategoryContent = {
  bscba: [
    [
      'Welke term, bedacht door Henri Cartier-Bresson, beschrijft het vastleggen van een gebeurtenis op het meest veelzeggende visuele en emotionele moment?',
      [
        'Het beslissende moment',
        'Het gouden uur',
        'Het verdwijnpunt',
        'De regel van derden',
      ],
      0,
      'Cartier-Bresson gebruikte "het beslissende moment" voor het ogenblik waarop vorm en inhoud in het beeld precies samenvallen.',
    ],
    [
      'Dorothea Lange\'s foto "Migrant Mother" werd een icoon van welke historische periode?',
      [
        'De Grote Depressie',
        'De Eerste Wereldoorlog',
        'Het Gilded Age',
        'Het Progressive Era',
      ],
      0,
      'Lange maakte het portret in 1936 voor de Farm Security Administration, als document van ontheemde landarbeiders tijdens de crisisjaren.',
    ],
    [
      'Welke fotograaf was medeoprichter van Magnum Photos, het coöperatieve bureau waarmee fotografen zelf de rechten op hun eigen beeld hielden?',
      [
        'Robert Capa',
        'Ansel Adams',
        'Man Ray',
        'Diane Arbus',
      ],
      0,
      'Capa richtte Magnum in 1947 op, samen met Cartier-Bresson, David Seymour en George Rodger, en gaf fotojournalisten zo creatieve en juridische zeggenschap.',
    ],
    [
      'Waar staat Diane Arbus vooral om bekend in haar portretten?',
      [
        'Mensen aan de rand van de samenleving',
        'Lege landschappen',
        'Abstracte stillevens',
        'Architecturale interieurs',
      ],
      0,
      'Arbus fotografeerde mensen naar wie de samenleving liever niet keek, van circusartiesten tot mensen met een beperking, met een directheid die niets verbloemde.',
    ],
    [
      'Tot welk genre behoort straatfotografie het meest?',
      [
        'Ongeposeerde beelden van het dagelijks leven in de openbare ruimte',
        'Geposeerde portretsessies',
        'Studiofotografie van producten',
        'Luchtfoto\'s van landschappen',
      ],
      0,
      'Straatfotografie legt spontane, ongeregisseerde momenten uit het dagelijks leven vast, doorgaans zonder poseren of enscenering.',
    ],
    [
      'Welk museum richtte een van de eerste afdelingen op die zich specifiek met fotografie bezighield, en hielp zo het medium als beeldende kunst te vestigen?',
      [
        'Het Museum of Modern Art',
        'Het Louvre',
        'Het British Museum',
        'De Uffizi',
      ],
      0,
      'MoMA startte in 1940 een fotografieafdeling en behandelde foto\'s als kunstobjecten die het waard waren om te verzamelen en te tonen.',
    ],
    [
      'Welke fotograaf werd beroemd om intieme portretten van beroemdheden voor tijdschriften als Rolling Stone en Vanity Fair?',
      [
        'Annie Leibovitz',
        'Cindy Sherman',
        'Berenice Abbott',
        'Lee Miller',
      ],
      0,
      'Leibovitz bouwde haar naam op met geënsceneerde, theatrale portretten van beroemdheden, van John Lennon en Yoko Ono tot hedendaagse filmsterren.',
    ],
    [
      'Wat houdt de compositieregel "regel van derden" in?',
      [
        'Belangrijke elementen plaatsen op denkbeeldige rasterlijnen in plaats van precies in het midden',
        'Altijd precies een derde van het beeld met lucht vullen',
        'Elke foto opdelen in drie afzonderlijke afdrukken',
        'Alleen drie tinten gebruiken: zwart, wit en grijs',
      ],
      0,
      'De regel van derden is een compositierichtlijn die het onderwerp op de lijnen van een 3x3-raster plaatst, wat doorgaans dynamischer werkt dan strikt centreren.',
    ],
    [
      'Welk type camera legt een scène vast met een extreem breed beeldveld, soms meer dan 180 graden?',
      [
        'Een panoramacamera',
        'Een gaatjescamera',
        'Een direct-klare camera',
        'Een tweeoogreflexcamera',
      ],
      0,
      'Panoramacamera\'s gebruiken een draaiende lens of een breed filmformaat om een weids horizontaal beeld vast te leggen dat een gewone lens niet vangt.',
    ],
    [
      'Wat is een "fotoboek", in tegenstelling tot een fototentoonstelling?',
      [
        'Een doordachte reeks foto\'s uitgegeven als zelfstandig boek',
        'Een digitaal fotoalbum op een telefoon',
        'Een technische handleiding voor cameraonderhoud',
        'Een plakboek met familiekiekjes',
      ],
      0,
      'Een fotoboek is een eigen kunstvorm: de volgorde, het tempo en de opeenvolging van beelden werken op een manier die een expositiewand nooit kan evenaren.',
    ],
    [
      'Vivian Maier, wier werk pas na haar dood werd ontdekt, werkte in het dagelijks leven als wat?',
      [
        'Kindermeisje',
        'Fotojournalist',
        'Museumconservator',
        'Modefotograaf',
      ],
      0,
      'Maier maakte in haar vrije tijd meer dan 150.000 straatfoto\'s terwijl ze als kindermeisje werkte in Chicago; haar archief kwam pas na haar dood in 2009 aan het licht.',
    ],
    [
      'Waar staat het werk van Sebastião Salgado vooral om bekend?',
      [
        'Grootschalige documentaireseries over arbeid, migratie en het milieu',
        'Abstracte macrofotografie van insecten',
        'Modereportages voor luxemerken',
        'Portretten van Hollywoodsterren',
      ],
      0,
      'Salgado is bekend van indrukwekkende zwart-witprojecten als "Workers" en "Genesis", over de relatie tussen mens, land en arbeid.',
    ],
    [
      'Hoe wordt een zelfportret dat je op armlengte met je eigen camera neemt tegenwoordig meestal genoemd?',
      [
        'Een selfie',
        'Een candid',
        'Een borstbeeld',
        'Een vignet',
      ],
      0,
      'Het zelfportret in de fotografie bestaat al ruim een eeuw langer dan de smartphone, maar "selfie" werd de gangbare term voor de informele, met de hand gemaakte variant.',
    ],
    [
      'Waarop moet zwart-witfotografie vooral steunen om diepte en sfeer te creëren, nu kleur ontbreekt?',
      [
        'Contrast en toonwaarde',
        'Uitsluitend scherptediepte',
        'Uitsluitend bewegingsonscherpte',
        'Symmetrie van het onderwerp',
      ],
      0,
      'Zonder kleur is monochrome fotografie afhankelijk van licht, schaduw en grijstinten om sfeer, vorm en diepte op te bouwen.',
    ],
    [
      'Waarom is William Henry Fox Talbots "The Pencil of Nature", uitgegeven in de jaren 1840, van belang?',
      [
        'Het was een van de eerste commercieel uitgegeven boeken met foto\'s als illustratie',
        'Het was een instructieboek over fotograferen voor een breed publiek',
        'Het was een van de eerste museale tentoonstellingen van fotografie als kunst',
        'Het was het eerste fototijdschrift met betalende abonnees',
      ],
      0,
      'Talbots boek uit 1844 combineerde zijn calotypie-afdrukken met tekst, en gold daarmee als een van de eerste commerciële uitgaven met echte fotografische illustraties.',
    ],
  ],

  msc: [
    [
      'Welk onderwerp fotografeerde de "New Topographics"-beweging van de jaren zeventig, in afwijking van de romantische landschapstraditie?',
      [
        'Door de mens veranderde voorstedelijke en industriële landschappen',
        'Ongerepte, door de mens onaangeraakte wildernis',
        'In een studio opgestelde stillevens',
        'Formele koninklijke portretten',
      ],
      0,
      'De tentoonstelling "New Topographics" uit 1975 toonde nuchtere beelden van parkeerplaatsen, nieuwbouwwijken en industrieterreinen in plaats van verheven landschappen zoals bij Ansel Adams.',
    ],
    [
      'Wat probeerde August Sander te bereiken met zijn project "Mensen van de twintigste eeuw"?',
      [
        'Een systematische visuele typologie van de Duitse samenleving naar beroep en klasse',
        'Een register van uitsluitend adellijke families in Europa',
        'Een studie die zich uitsluitend richtte op kinderen',
        'Ongeposeerde beelden van politieke bijeenkomsten',
      ],
      0,
      'Sander ordende zijn portretten in maatschappelijke categorieën als boeren, ambachtslieden en kunstenaars, en bouwde zo een ambitieus sociologisch archief op via portretfotografie.',
    ],
    [
      'Waarmee bouwde Weegee (Arthur Fellig) zijn reputatie op in het New York van de jaren dertig en veertig?',
      [
        'Misdaadscènes en het nachtleven van de stad',
        'Balletvoorstellingen',
        'Botanische tuinen',
        'Directiekamers van bedrijven',
      ],
      0,
      'Weegee luisterde de politieradio af om als eerste bij plaatsen delict te zijn, wat resulteerde in rauwe, met flitslicht geschoten sensatiefotografie.',
    ],
    [
      'Met welke onconventionele methode maakte Man Ray zijn "rayogrammen"?',
      [
        'Voorwerpen rechtstreeks op lichtgevoelig papier leggen, zonder camera',
        'Film dubbel belichten in een gewone camera',
        'Afgedrukte foto\'s met de hand overschilderen',
        'Fotograferen door gekleurde glasfilters',
      ],
      0,
      'Rayogrammen zijn cameraloze fotogrammen, gemaakt door voorwerpen op lichtgevoelig papier te leggen en dat vervolgens rechtstreeks aan licht bloot te stellen.',
    ],
    [
      'Waarom viel Robert Franks fotoboek "The Americans" uit 1958 op?',
      [
        'Door een rauwe, ongepolijste blik op de Verenigde Staten die haaks stond op het gangbare patriottische beeld',
        'Door een geïdealiseerd ansichtkaartbeeld van Amerikaanse welvaart',
        'Door een puur architecturaal overzicht van Amerikaanse steden',
        'Door een chronologisch verslag van presidentsverkiezingen',
      ],
      0,
      'Franks korrelige, scheefgetrokken beelden van het gewone Amerikaanse leven schokten destijds critici, maar werden later enorm invloedrijk voor documentaire fotografen.',
    ],
    [
      'Welke, voorheen weggezette, fotografische benadering wordt William Eggleston vooral toegeschreven als kunstvorm te hebben gevestigd?',
      [
        'Kleurenfotografie',
        'Gaatjescamera-fotografie',
        'Luchtfotografie',
        'Polaroid-achtige directklaarfotografie',
      ],
      0,
      'Voor Egglestons tentoonstelling in het MoMA in 1976 werd kleurenfotografie vooral als commercieel gezien; zijn werk hielp het als serieuze kunstvorm te vestigen.',
    ],
    [
      'Welk artistiek uitgangspunt verdedigde de f/64 Group, waartoe ook Ansel Adams en Edward Weston behoorden?',
      [
        'Scherpe, onbewerkte "straight" fotografie boven schilderachtige zachtheid',
        'Uitsluitend abstracte, wazige composities',
        'Uitgebreid met de hand inkleuren van afdrukken',
        'Alleen stedelijke onderwerpen fotograferen',
      ],
      0,
      'Genoemd naar een kleine lensopening die maximale scherpte geeft, verwierp de groep de manipulatie van de Pictorialisten ten gunste van heldere, directe fotografische vorm.',
    ],
    [
      'Wat maakte de ontdekking van Vivian Maiers negatieven zo belangrijk voor de fotografiegeschiedenis?',
      [
        'Ze onthulde een groot straatfotograaf die tijdens haar leven nooit erkenning had gezocht',
        'Ze bewees dat straatfotografie eerder was uitgevonden dan gedacht',
        'Ze bracht onbekend werk van Diane Arbus aan het licht',
        'Ze beslechtte een langlopend geschil over de uitvinding van kleurenfilm',
      ],
      0,
      'Maiers omvangrijke, ongeziene archief riep vragen op over auteurschap, artistieke intentie, en hoe de kunstgeschiedenis werk erkent dat buiten de gangbare instituties is gemaakt.',
    ],
    [
      'Wat voor beelden bevat Cindy Shermans reeks "Untitled Film Stills"?',
      [
        'Sherman die zichzelf vertolkt als fictieve vrouwelijke personages uit verzonnen films',
        'Documentaire portretten van aspirant-actrices',
        'Beelden van achter de schermen bij echte filmproducties',
        'Landschapsfoto\'s van filmlocaties in Hollywood',
      ],
      0,
      'Sherman fotografeerde zichzelf in verschillende personages die aan filmgenres uit het midden van de twintigste eeuw doen denken, als onderzoek naar identiteit en door media geconstrueerde vrouwelijkheid.',
    ],
    [
      'Waar staat het fotowerk van Alexander Rodchenko om bekend, als visuele uitdrukking van het constructivisme?',
      [
        'Opvallende, ongebruikelijke camerastandpunten van boven- en onderaf',
        'Zachtgetekende, romantische portretten',
        'Gedempte, ontverzadigde kleuren',
        'Symmetrische, klassieke composities',
      ],
      0,
      'Rodchenko gebruikte extreme hoeken om het gangbare gezichtspunt te doorbreken, in lijn met het constructivistische enthousiasme voor een dynamische, industriële moderniteit.',
    ],
    [
      'Wat was er bijzonder aan Edward Westons foto\'s van groenten, zoals zijn beroemde pepers?',
      [
        'Hij fotografeerde ze als abstracte, sculpturale vormen in plaats van als voedsel',
        'Hij fotografeerde ze altijd in staat van verval, als symbool van vergankelijkheid',
        'Hij fotografeerde ze uitsluitend in kleur om de versheid te benadrukken',
        'Hij schikte ze zodanig dat ze menselijke portretten vormden',
      ],
      0,
      'Westons close-ups met precies licht veranderden alledaagse groenten in vormen die aan het menselijk lichaam en klassieke beeldhouwkunst deden denken.',
    ],
    [
      'Als welk soort uitgave werd Aperture opgericht in 1952, door onder anderen Ansel Adams en Dorothea Lange?',
      [
        'Een serieus kwartaalblad gewijd aan fotografie als kunst',
        'Een commerciële cameracatalogus',
        'Een katernbijlage van een sensatiekrant',
        'Een technisch overheidsbulletin',
      ],
      0,
      'Aperture gaf kunstfotografie een eigen kritisch en uitgeverijplatform, los van de commerciële fototijdschriften van die tijd.',
    ],
    [
      'Tijdens welk soort verandering documenteerde Berenice Abbott de stad in haar project "Changing New York"?',
      [
        'Snelle modernisering en de sloop van oudere architectuur',
        'Het herstel van de stad na een natuurramp',
        'De stichting van de stad als koloniale nederzetting',
        'Een periode van bevolkingsafname',
      ],
      0,
      'In de jaren dertig fotografeerde Abbott systematisch hoe oudere gebouwen in New York plaatsmaakten voor wolkenkrabbers, en legde zo een verdwijnend stadsbeeld vast.',
    ],
    [
      'Wat is doorgaans het belangrijkste verschil tussen fotojournalistiek en documentaire fotografie?',
      [
        'Fotojournalistiek dient actuele nieuwsverslaggeving; documentair werk is vaker een langlopend, persoonlijker project',
        'Fotojournalisten werken alleen in kleur en documentaire fotografen alleen in zwart-wit',
        'Documentaire fotografen publiceren hun werk nooit',
        'Fotojournalisten fotograferen uitsluitend oorlogsgebieden',
      ],
      0,
      'Beide leggen echte gebeurtenissen vast, maar fotojournalistiek is gebonden aan de nieuwscyclus, terwijl documentaire fotografie zich vaak jarenlang en persoonlijker ontvouwt.',
    ],
    [
      'Naar welke rol stapte Lee Miller over vanuit haar carrière als gevierd fotomodel, tijdens de Tweede Wereldoorlog?',
      [
        'Oorlogscorrespondent en fotograaf voor Vogue',
        'Officier bij de militaire inlichtingendienst',
        'Verpleegkundige aan het front',
        'Radiopresentator',
      ],
      0,
      'Miller fotografeerde de Blitz, de bevrijding van Parijs en Duitse concentratiekampen voor het Britse Vogue, een buitengewone overstap vanuit haar modellencarrière.',
    ],
  ],

  phd: [
    [
      'Hoe noemt Roland Barthes in "Camera Lucida" het persoonlijke, doorborende detail in een foto dat een kijker emotioneel raakt?',
      [
        'Punctum',
        'Studium',
        'Aura',
        'Referent',
      ],
      0,
      'Barthes onderscheidde het "studium" (de algemene, cultureel gedeelde interesse van een foto) van het "punctum", het toevallige detail dat de kijker persoonlijk raakt.',
    ],
    [
      'Volgens Walter Benjamins essay "Het kunstwerk in het tijdperk van zijn technische reproduceerbaarheid" tast fotografische reproductie wat van een kunstwerk aan?',
      [
        'De aura, de unieke aanwezigheid in tijd en plaats',
        'De marktwaarde',
        'De fysieke houdbaarheid',
        'De kleurgetrouwheid',
      ],
      0,
      'Benjamin stelde dat technische reproductie een origineel kunstwerk zijn unieke "aura" ontneemt, wat de manier waarop kunst wordt beleefd en gewaardeerd fundamenteel verandert.',
    ],
    [
      'Aan de hand van welke formele eigenschappen moest fotografie volgens John Szarkowski\'s invloedrijke boek uit 1966, voortkomend uit zijn conservatorschap bij MoMA, worden begrepen?',
      [
        'De eigen kenmerken van het medium zelf, zoals detail, kader, tijd en gezichtspunt',
        'De gelijkenis met schilderkunstige compositie',
        'De rol als zuiver wetenschappelijke documentatie',
        'De commerciële toepassing in reclame',
      ],
      0,
      'In "The Photographer\'s Eye" stelde Szarkowski voor fotografie te beoordelen op kwaliteiten die eigen zijn aan het medium, in plaats van op geleende schilderkunstige maatstaven.',
    ],
    [
      'Waarmee vergelijkt Susan Sontag in "On Photography" de daad van het fotograferen van een ander?',
      [
        'Een vorm van toe-eigening of symbolische agressie tegenover het onderwerp',
        'Een volstrekt neutrale, onschuldige handeling van registratie',
        'Een handeling die niet te onderscheiden is van schilderen',
        'Een religieus ritueel van herdenking',
      ],
      0,
      'Sontag betoogde dat het fotograferen van mensen een subtiele machtshandeling is, die onderwerpen tot objecten maakt die bezeten, verzameld en gecontroleerd kunnen worden.',
    ],
    [
      'Welke drie fotografen bracht Szarkowski\'s tentoonstelling "New Documents" uit 1967 bij MoMA samen als vernieuwers van het documentaire genre?',
      [
        'Diane Arbus, Lee Friedlander en Garry Winogrand',
        'Ansel Adams, Edward Weston en Paul Strand',
        'Man Ray, Alexander Rodchenko en László Moholy-Nagy',
        'Robert Capa, David Seymour en George Rodger',
      ],
      0,
      'De tentoonstelling betoogde dat deze fotografen de documentaire stijl gebruikten voor persoonlijke expressie in plaats van maatschappelijke hervorming, een verschuiving die Szarkowski cruciaal achtte.',
    ],
    [
      'Welk universeel thema wilde Edward Steichens MoMA-tentoonstelling "The Family of Man" uit 1955 uitdragen?',
      [
        'Een gedeelde menselijke ervaring over alle culturen en naties heen',
        'De technische superioriteit van Amerikaanse camera-apparatuur',
        'De neergang van de traditionele portretkunst',
        'De opkomst van de abstracte fotografie',
      ],
      0,
      'Met meer dan 500 beelden uit tientallen landen presenteerde Steichens tentoonstelling fotografie als bewijs van een gedeelde menselijkheid, al werd die universaliserende aanname later door critici bestreden.',
    ],
    [
      'Welke kritiek leverden latere wetenschappers, met name Allan Sekula, op "The Family of Man"?',
      [
        'De tentoonstelling vlakte politieke en historische verschillen af tot een sentimentele universaliteit',
        'Er stond geen enkele foto van een vrouwelijke fotograaf in',
        'Ze werd volledig gefinancierd door een concurrerende krant',
        'Alle Amerikaanse fotografen waren uitgesloten',
      ],
      0,
      'Sekula en anderen betoogden dat de humanistische framing van de tentoonstelling echte ongelijkheden in macht, klasse en geschiedenis wegmoffelde achter een geruststellende gelijkenis.',
    ],
    [
      'Waar verwijst "indexicaliteit" naar, in kritische geschriften over fotografie?',
      [
        'Het fysieke, causale spoor dat het licht in een foto achterlaat',
        'Het numerieke catalogussysteem dat musea gebruiken',
        'De alfabetische ordening van het archief van een fotograaf',
        'De resolutie van de uiteindelijke afdruk',
      ],
      0,
      'Omdat licht het beeld fysiek afdrukt, wordt een foto vaak beschreven als een "index" van haar onderwerp, in tegenstelling tot een geschilderde of getekende voorstelling.',
    ],
    [
      'Waar legde het aan het Bauhaus verbonden concept "Neues Sehen", geassocieerd met László Moholy-Nagy, de nadruk op?',
      [
        'Ongewone gezichtspunten en experimentele technieken die nieuwe manieren van kijken lieten zien',
        'Een strikte terugkeer naar negentiende-eeuwse portretconventies',
        'Uitsluitend gebruik van natuurlijk, onbewerkt licht',
        'Het afwijzen van elke vorm van camerabeeld',
      ],
      0,
      'Moholy-Nagy verdedigde fotogrammen, extreme hoeken en meervoudige belichtingen om fotografie voorbij de conventionele voorstelling te duwen.',
    ],
    [
      'Wat onderscheidt het "studium" van een foto, in de terminologie van Barthes, van het "punctum"?',
      [
        'Studium is de algemene, culturele of informatieve interesse die elke kijker kan delen',
        'Studium is de emotionele pijn die slechts één kijker voelt',
        'Studium verwijst uitsluitend naar de technische belichtingsinstellingen van een foto',
        'Studium beschrijft de geldwaarde van een foto',
      ],
      0,
      'Studium is de brede, cultureel gecodeerde betekenis die een kijker kan bespreken en analyseren; punctum is het persoonlijke, niet te analyseren detail dat hen persoonlijk raakt.',
    ],
    [
      'Welk breder theoretisch kader paste Rosalind Krauss in haar geschriften over fotografie herhaaldelijk toe op het medium?',
      [
        'Structuralistische en poststructuralistische theorie',
        'Uitsluitend marxistisch economisch determinisme',
        'Uitsluitend freudiaanse droomanalyse',
        'Klassieke aristotelische esthetica',
      ],
      0,
      'Krauss putte uit structuralistisch en poststructuralistisch denken, en besprak met name de indexicale aard van fotografie en de relatie ervan tot de "originaliteit" van de avant-garde.',
    ],
    [
      'Wat was de betekenis van de werkwijze van Ansel Adams en Edward Weston voor de acceptatie van fotografie als beeldende kunst door musea en galeries?',
      [
        'Ze hielpen instituten ertoe te bewegen afdrukken als unieke, verzamelbare kunstobjecten te behandelen',
        'Ze weigerden ooit hun afdrukken te verkopen',
        'Ze hielden vol dat fotografie de schilderkunst als kunst nooit kon evenaren',
        'Ze stapten later in hun leven over naar het schilderen',
      ],
      0,
      'Hun zorgvuldige afdruktechniek en pleitbezorging, deels via de f/64 Group en Adams\'s latere technische geschriften, hielpen fotografische afdrukken de status en waarde van kunstobjecten te geven.',
    ],
    [
      'Wat is een "vintage print" binnen de fotografische connaisseurschap en kunstmarkt?',
      [
        'Een afdruk die de fotograaf zelf maakte rond het moment waarop het beeld werd vastgelegd',
        'Elke zwart-witafdruk, ongeacht wanneer die is gemaakt',
        'Een afdruk gemaakt met uitsluitend negentiende-eeuwse chemische procedés',
        'Een reproductie die pas na de dood van de fotograaf is geautoriseerd',
      ],
      0,
      'Vintage prints worden hoger gewaardeerd dan latere afdrukken omdat ze het dichtst bij de oorspronkelijke intentie en het historische moment van de fotograaf staan.',
    ],
    [
      'Hoe compliceerde Walter Benjamins begrip "aura" de positie van fotografie ten opzichte van oudere kunstvormen zoals de schilderkunst?',
      [
        'De oneindige reproduceerbaarheid van fotografie ondermijnde het idee van een enkel, authentiek origineel',
        'Fotografie kreeg door haar realisme onmiddellijk meer aura dan de schilderkunst',
        'Aura geldt alleen voor beeldhouwkunst, niet voor tweedimensionale media',
        'Benjamin stelde dat fotografie geen enkele relatie tot aura had',
      ],
      0,
      'Omdat foto\'s identiek en eindeloos gereproduceerd kunnen worden, zag Benjamin het medium als centraal in de bredere teloorgang van "aura" in de moderne kunst.',
    ],
    [
      'Welk curatorieel uitgangspunt vormde de basis van Szarkowski\'s bredere project bij de fotografieafdeling van MoMA?',
      [
        'Fotografie verdiende het om op haar eigen formele voorwaarden te worden bestudeerd, niet als mindere versie van de schilderkunst',
        'Fotografie moest altijd naast de bijbehorende negatieven worden getoond',
        'Alleen anonieme of amateurfotografie hoorde in een museum thuis',
        'Foto\'s mochten nooit groter worden afgedrukt dan het originele negatief',
      ],
      0,
      'Szarkowski\'s curatoriële missie was om het eigen esthetische vocabulaire van de fotografie te definiëren en te verdedigen, los van maatstaven ontleend aan schilder- of beeldhouwkunst.',
    ],
  ],

  professor: [
    [
      'Waarmee zette Andreas Gursky\'s foto "Rhein II" een mijlpaal op de kunstmarkt?',
      [
        'Het werd bij de veiling in 2011 de duurste foto ooit verkocht op dat moment',
        'Het werd de eerste foto die door het Louvre werd aangekocht',
        'Het werd de eerste kleurenfoto die in het MoMA werd tentoongesteld',
        'Het werd de enige foto ooit opgenomen in een groot schilderkunstretrospectief',
      ],
      0,
      'Gursky\'s digitaal bewerkte, minimalistische beeld van de Rijn bracht in 2011 ruim 4 miljoen dollar op, symbool van de intrede van fotografie in de gevestigde kunstmarkt.',
    ],
    [
      'Welk theoretisch bezwaar brengt Rosalind Krauss naar voren tegen het idee van fotografische "originaliteit" binnen de avant-garde?',
      [
        'De eindeloze reproduceerbaarheid van fotografie ondermijnt de claim op een enkel, oorspronkelijk avant-gardewerk',
        'Fotografie levert altijd, net als een schilderij, één onherhaalbaar origineel op',
        'Originaliteit is irrelevant voor elke discussie over fototheorie',
        'Krauss stelt dat fotografie ouder is dan het concept originaliteit zelf',
      ],
      0,
      'Krauss betoogde dat de mythe van originaliteit binnen de avant-garde botst met het mechanisch reproduceerbare karakter van fotografie, omdat geen enkele afdruk de unieke auteursstatus heeft die een uniek doek wel heeft.',
    ],
    [
      'Welk institutioneel gebruik van fotografie onderzoekt Allan Sekula\'s kritische essay "The Body and the Archive"?',
      [
        'Criminele identificatie en maatschappelijk toezicht in de negentiende eeuw',
        'Koninklijke portretkunst in opdracht van Europese vorstenhuizen',
        'Vroege experimenten met kleurenfotografie',
        'Reclamecampagnes voor consumptiegoederen',
      ],
      0,
      'Sekula liet zien hoe fotografie verweven raakte met politiewerk en pseudowetenschappelijke classificatie, met name via het identificatiesysteem van Alphonse Bertillon.',
    ],
    [
      'Wat is de betekenis van het toepassen van Peirce\'s semiotische categorie van de "index" op een foto?',
      [
        'Het plaatst de foto als fysiek veroorzaakt door, en dus evidentieel verbonden met, haar referent',
        'Het verwijst alleen naar de plaats van een foto in het catalogussysteem van een museum',
        'Het beschrijft foto\'s die lijsten of indexen als onderwerp afbeelden',
        'Het is een term die uitsluitend voor digitale, niet analoge, fotografie geldt',
      ],
      0,
      'Charles Sanders Peirce\'s semiotiek onderscheidt de "index" (een teken fysiek verbonden met zijn object) van icoon en symbool; de chemische of optische oorzakelijkheid van fotografie wordt vaak als bij uitstek indexicaal aangehaald.',
    ],
    [
      'Hoe compliceerde Geoffrey Batchens onderzoek het gangbare verhaal over de "uitvinding van de fotografie", dat om Talbot en Daguerre draait?',
      [
        'Hij documenteerde talloze minder bekende figuren die vóór 1839 onafhankelijk van elkaar fotografische processen ontwikkelden',
        'Hij betoogde dat fotografie nooit werkelijk is uitgevonden, maar altijd al als natuurverschijnsel bestond',
        'Hij schreef de uitvinding volledig toe aan Nicéphore Niépce alleen',
        'Hij stelde dat er vóór 1850 geen enkel fotografisch proces bestond',
      ],
      0,
      'Batchens "Burning with Desire" bracht een breder, diffuser verhaal van fotografisch experiment door heel Europa in kaart, wat het nette verhaal van twee uitvinders ondermijnde.',
    ],
    [
      'Welk kritisch onderscheid maakt Sekula\'s essay "The Traffic in Photographs" over de veronderstelde neutraliteit van fotografie?',
      [
        'De betekenis van een foto wordt gevormd door de institutionele en economische context waarin ze circuleert',
        'Foto\'s zijn door hun mechanische aard volledig vrij van ideologische inhoud',
        'Alleen geënsceneerde foto\'s dragen ideologische betekenis; ongeposeerde beelden zijn neutraal',
        'De betekenis van een foto ligt voorgoed vast op het moment van opname',
      ],
      0,
      'Sekula betoogde dat de betekenis van een foto verschuift naargelang waar en hoe ze circuleert, in een krant, een galerie of een archief, wat elke claim op inherente neutraliteit ondermijnt.',
    ],
    [
      'Wat was kunsthistorisch van belang aan de tentoonstelling "Mirrors and Windows" uit 1978, samengesteld door John Szarkowski?',
      [
        'Ze plaatste de naoorlogse Amerikaanse fotografie op een spectrum van persoonlijke expressie tot documentaire observatie',
        'Ze was de eerste tentoonstelling die alle kleurenfotografie uitsloot',
        'Ze toonde uitsluitend negentiende-eeuwse daguerreotypieën',
        'Ze markeerde het verdwijnen van fotografie uit de vaste collectie van MoMA',
      ],
      0,
      'Szarkowski\'s onderscheid tussen "mirrors" (persoonlijk, expressief) en "windows" (observerend, documentair) werd een veelgebruikt kader om naoorlogse fotografische praktijken te ordenen.',
    ],
    [
      'Welk aspect van MoMA\'s historische rol in de fotografie bekritiseert Christopher Phillips\'s essay "The Judgment Seat of Photography"?',
      [
        'De buitensporige macht van de conservatoren om de canon en waarde van fotografie te bepalen',
        'De weigering om ooit fotografie als kunst tentoon te stellen',
        'De uitsluitende focus op Europese fotografen',
        'De vroege omarming van digitale fotografie boven film',
      ],
      0,
      'Phillips betoogde dat MoMA\'s fotografieconservatoren, met name Steichen en Szarkowski, feitelijk als poortwachters optraden die bepaalden welke fotografische praktijken als kunst golden.',
    ],
    [
      'Wat stelt Ariella Azoulays concept van "het burgerlijk contract van de fotografie" over de verhouding tussen fotograaf, onderwerp en kijker?',
      [
        'Fotografie schept een voortdurende burgerlijke relatie van wederzijdse verplichting tussen alle drie partijen',
        'Alleen de fotograaf heeft rechten of verplichtingen met betrekking tot een beeld',
        'De toestemming van het onderwerp is wettelijk vereist voordat een foto mag bestaan',
        'Het concept geldt uitsluitend voor foto\'s van politieke leiders',
      ],
      0,
      'Azoulay betoogde dat fotografie een gedeelde burgerlijke ruimte schept waarin gefotografeerde onderwerpen zeggenschap houden over hoe hun beeld wordt gebruikt en begrepen, voorbij het simpele eigendom van de fotograaf.',
    ],
    [
      'Hoe gingen de kunstenaars van de "Pictures Generation" van eind jaren zeventig en tachtig, onder wie Cindy Sherman en Richard Prince, om met de relatie tussen fotografie en massamedia?',
      [
        'Ze eigenden zich bestaand mediabeeld toe en ensceneerden het opnieuw, om representatie zelf te bevragen',
        'Ze weigerden elk gebruik van toegeëigend of geleend beeldmateriaal',
        'Ze werkten uitsluitend met negentiende-eeuwse fotografische procedés',
        'Ze richtten zich alleen op landelijke onderwerpen, ver van de media',
      ],
      0,
      'De Pictures Generation gebruikte toe-eigening en herenscenering om te onderzoeken hoe massamedia identiteit, gender en verlangen construeren.',
    ],
    [
      'Welke gedachte ligt ten grondslag aan Vilém Flussers filosofie van de fotografie over de camera als "apparaat"?',
      [
        'Fotografen bewegen zich binnen een geprogrammeerde reeks mogelijkheden die het toestel zelf voorschrijft',
        'De camera is een volledig neutraal werktuig zonder invloed op het resulterende beeld',
        'Alleen mechanische, niet-elektronische camera\'s gelden als apparaat',
        'Flusser stelde dat camera\'s de handelingsvrijheid van de fotograaf volledig tenietdoen',
      ],
      0,
      'Flusser stelde dat camera\'s een eindig "programma" van mogelijke beelden coderen, en dat fotografen grotendeels combinaties verkennen die al in dat programma besloten liggen, in plaats van met volledige vrijheid te handelen.',
    ],
    [
      'Wat is de kritische betekenis van de ontdekking in 2007 en de latere postume tentoonstelling van Vivian Maiers negatieven, zoals bediscussieerd onder fotografiehistorici?',
      [
        'Ze wierp vragen op over auteurschap, canonvorming, en wie erkenning krijgt als kunstenaar',
        'Ze beslechtte een decennialang authenticatiegeschil over de negatieven van Ansel Adams',
        'Ze was het eerste gedocumenteerde geval van straatfotografie',
        'Ze bewees dat alle grote twintigste-eeuwse fotografen anoniem werkten',
      ],
      0,
      'Omdat Maier nooit publicatie of galerievertegenwoordiging had gezocht, dwong haar postume roem wetenschappers te heroverwegen hoe institutionele erkenning bepaalt wie tot de fotografische canon gaat behoren.',
    ],
    [
      'Welke uitdaging vormt beeldbewerkingssoftware in het digitale tijdperk voor Bazins en Barthes\'s theorieën over fotografische indexicaliteit?',
      [
        'Ze ondermijnt het veronderstelde causale, onbewerkte verband tussen beeld en referent waarop de oudere theorie steunde',
        'Ze heeft geen invloed op indexicaliteit, omdat digitale bestanden eveneens chemisch tot stand komen',
        'Ze versterkt de indexicaliteit doordat beelden preciezer worden',
        'Ze raakt uitsluitend bewegend beeld, niet de stilstaande foto',
      ],
      0,
      'De klassieke theorie berustte op het directe fysieke of chemische spoor dat fotografie van de werkelijkheid achterlaat; wijdverspreide digitale bewerking compliceert de aanname dat een foto rechtstreeks wordt veroorzaakt door wat ze afbeeldt.',
    ],
    [
      'Welke curatoriële en kritische inzet brachten de Deutsche Börse Photography Prize en vergelijkbare kunstprijzen met zich mee voor de institutionele status van fotografie?',
      [
        'Ze markeren de volledige opname van fotografie in de prestige- en marktstructuren van de hedendaagse beeldende kunst',
        'Ze bestaan specifiek om fotografie uit te sluiten van bredere erkenning in de kunstwereld',
        'Ze zijn opgericht om fotografieapparatuur voor studenten te financieren',
        'Ze worden uitsluitend toegekend aan oorlogsfotojournalisten',
      ],
      0,
      'Prijzen als de Deutsche Börse Photography Prize plaatsen fotografie binnen dezelfde prestige-economie als schilder- en beeldhouwkunst, met kritische en marktmatige erkenning tot gevolg.',
    ],
    [
      'Hoe herziet of compliceert Susan Sontags latere werk "Regarding the Pain of Others" de argumenten die ze eerder in "On Photography" naar voren bracht?',
      [
        'Ze herziet haar eerdere scepsis en erkent dat beelden van leed nog altijd een oprechte ethische reactie kunnen oproepen',
        'Ze trekt elke bewering uit "On Photography" volledig in',
        'Ze betoogt dat oorlogsfotografie onder geen enkele omstandigheid gepubliceerd mag worden',
        'Ze stelt dat foto\'s van leed geen enkel effect op kijkers hebben',
      ],
      0,
      'Decennia later geschreven, wordt "Regarding the Pain of Others" vaak gelezen als Sontags terugblik op, en nuancering van, haar eerdere argumenten over het vermogen van fotografie om kijkers af te stompen.',
    ],
  ],
};
